import React, { useContext, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { CloseOutlined } from "@ant-design/icons";
import { Radio, Space, Tooltip } from "antd";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "antd";
import { useSlotCancellation } from "./store";
import { useCustomer } from "modules/dashboards/actionables/store";
const { TextArea } = Input;

function SlotCancellationCanvas({ data }) {
  const { postSlotCancellation } = useSlotCancellation();
  const [show, setShow] = useState(false);
  const [value, setValue] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const { fetchCustomerData } = useCustomer();

  const onChange = (e) => {
    setValue(e.target.value);
  };
  const onChangeText = (e) => {
    setTextAreaValue(e.target.value);
  };

  const handleCancelSlot = () => {
    const payload = {
      slot_id: data?._id,
      comment: value === "others" ? textAreaValue : value,
    };
    postSlotCancellation(payload, toast, fetchCustomerData, data?.case?.id );
    handleClose();
    handleClose();
    setValue("");
    setTextAreaValue("");
  };

  const handleShow = () => {
    setShow(true);
    setValue("");
    setTextAreaValue("");
  };

  const handleClose = () => {
    setShow(false);
    setValue("");
    setTextAreaValue("");
  };

  return (
    <>
      <Tooltip title="Cancel Booking">
        <Button
          style={{ flex: 1 }}
          className="py-2 ms-2 cursor-pointer"
          onClick={handleShow}
        >
          <span className="fs-1 fw-bold">
            {" "}
            <CloseOutlined />
          </span>
        </Button>
      </Tooltip>
      <Offcanvas
        style={{ width: "30vw", Index: 1019 }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title className="ms-3">
            Please Enter the Reason for Slot Cancellation
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="scrollable-section mt-n4">
          <div>
            <div className="mx-3 mt-5">
              <div className="flex flex-col xl:items-center">
                <div className="mt-6">
                  <div className="">
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio
                          value="have already clarified my concern"
                          className="border w-100 border rounded-3 p-2"
                        >
                          have already clarified my concern
                        </Radio>
                        <Radio
                          value="got support from chat"
                          className="border w-100 border rounded-3 p-2"
                        >
                          got support from chat
                        </Radio>
                        <Radio
                          value="will connect later as did'nt get preferred slot timing"
                          className="border w-100 border rounded-3 p-2"
                        >
                          will connect later as did'nt get preferred slot timing
                        </Radio>
                        <Radio
                          value="spoken to traya team"
                          className="border w-100 border rounded-3 p-2"
                        >
                          spoken to traya team
                        </Radio>
                        <Radio
                          value="connected in a community"
                          className="border w-100 border rounded-3 p-2"
                        >
                          connected in a community
                        </Radio>
                        <Radio
                          value="others"
                          className="border w-100 border rounded-3 p-2"
                        >
                          Others
                        </Radio>
                        {value === "others" && (
                          <div className="mt-3">
                            <div vertical gap={32}>
                              <TextArea
                                showCount
                                maxLength={80}
                                value={textAreaValue}
                                onChange={onChangeText}
                                placeholder="can resize"
                              />
                            </div>
                          </div>
                        )}
                      </Space>
                    </Radio.Group>
                    <Button
                      className="float-end mt-4"
                      style={{ marginRight: "17%" }}
                      onClick={handleCancelSlot}
                    >
                      Confirm Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SlotCancellationCanvas;
